import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';

import { LanguageService } from '@core/services/language.service';

/**
 * Сообщает бэкенду, какой язык выбран в интерфейсе.
 *
 * Часть текстов продукта живёт строками в базе — названия характеристик, папок
 * и встроенных представлений, — и перевести их на клиенте нечем: это данные
 * пространства, а не подписи в шаблоне.
 *
 * Свой заголовок, а не `Accept-Language`: тот рассказывает про язык браузера,
 * то есть про настройки системы. Человек с английской ОС, переключивший
 * интерфейс на русский, получал бы английский каталог внутри русского экрана —
 * и отличить это от поломки было бы нечем. `x-lang` ставится рядом с
 * `x-space-id` и означает ровно одно: приложение выбрало этот язык.
 */
export const languageInterceptor: HttpInterceptorFn = (req, next) => {
  const language = inject(LanguageService).currentLang();

  return next(req.clone({ setHeaders: { 'x-lang': language } }));
};
